<template>
    <div>
        <div class="writeOff-container open-panel2 items-center lt-lg">низкое разрешение, функционал ограничен</div>
        <div class="writeOff-container gt-md"  v-bind:class="{'shadow-up-2':showFileContainer}">
           
                <div class="open-panel items-center" @click='toggleFileContainer' v-bind:class="{'open-panel-opened':showFileContainer}">готовность заказов | списание материала</div>        
                    <q-slide-transition :duration="100">                
                        <div class="file-container row no-wrap justify-between" v-if="showFileContainer">
                            <!-- вставляем файлы -->
                            <div style="width:100%">
                                <div v-for="f in writeOffFileList" :key='f.id'>
                                    <write-off-file
                                        :fileOff='f'
                                    />
                                </div>
                            </div>
                            <!-- вставляем элементы управления -->
                            <div class="control-container">
                                <q-select
                                v-model="writeOffMaterialType"
                                :options="materialTypeList"
                                inverted
                                color='primary'
                                @input='typeMaterialChange'
                                style="width:250px;"
                                />                
                                <q-select
                                v-model="writeOffMaterialNomenklatura"
                                :options="materialNomenklaturaList"
                                inverted
                                color='secondary'
                                style="margin-top:5px; margin-bottom:5px; width:250px;"
                                />

                                <q-input 
                                    v-model='materialCount'
                                    suffix='м.п.'
                                    prefix='списать:'
                                    align='center'
                                    inverted-light
                                    type='number'
                                    :min='0'
                                    :step='0.5'
                                    color='warning'
                                />
                                <div class="write-off-button-container justify-between row no-wrap">
                                    <q-btn 
                                        label="отмена" 
                                        style="margin-right:10px;width:100px;"
                                        outline
                                        dense
                                        icon='cancel'
                                        color="negative"
                                        @click='cancelWriteOff'
                                        :loading='clearing'
                                    />
                                    <q-btn 
                                        label="Списать"
                                        color="positive"
                                        icon='done'
                                        :loading='clearing'
                                        dense
                                        @click="writeOffFiles"
                                        style="width:120px;"
                                    />
                                </div>
                            </div>
                    </div>
                </q-slide-transition>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    nama : 'printTerminalWriteOff',
    
    components : {
        writeOffFile : () => import('./printTerminalWriteOffFile.vue'),
    },

    data () {
            return {
                showFileContainer : false,
                writeOffMaterialType : -1,
                writeOffMaterialNomenklatura : -1,
                materialCount : 0,
                clearing : false
            }
    },
    
    created() {
        if (this.$store.getters.getNomenklatura==0) {
            this.$store.dispatch('getNomenklatura')
            .then()
            .catch((error)=> {
                this.$admns.showNotify('Ошибка загрузки номенклатуры','error','Сообщение системы');
            })
        }
    },

    methods : {
        clearWriteOffParams() {
            this.showFileContainer = false;
            this.writeOffMaterialType = -1;
            this.writeOffMaterialNomenklatura = -1;
            this.materialCount = 0;
        },

        writeOffFiles() {
            var isOk = true;
            
            if (this.writeOffMaterialNomenklatura == -1) { // не задана наменклатура - списывать нельзя
                this.$admns.showNotify('Не выбран материал','error','Сообщение системы');
                isOk = false;
            }
            if (this.$store.getters.getWriteOffFileCount==0) {
                this.$admns.showNotify('Не выбраны файлы для списания','error','Сообщение системы');
                isOk = false;
            }

            if (!isOk) return; //Не прошли проверку- выходим

            var data = {
                matId : this.writeOffMaterialNomenklatura,
                quantity : this.materialCount,
            };
            this.clearing = true; // ставим флаг "loading"
            this.$store.dispatch('saveWriteOffFiles', data)
            .then(()=>{
                this.clearing = false;
                this.clearWriteOffParams();
                this.$admns.showNotify('Сборка списана','success','Сообщение системы');
            })
            .catch((error)=>{
                console.log(error);
                this.$admns.showNotify('Ошибка при списании','error','Сообщение системы');
                this.clearing = false;
            });

        },

        typeMaterialChange(){
            this.writeOffMaterialNomenklatura = -1;
        },

        toggleFileContainer() {
            this.showFileContainer = !this.showFileContainer;
        },

        cancelWriteOff() {
            this.$store.commit('clearWriteOffFiles');
// Обнуляем все параметры списания
            this.clearWriteOffParams();

        },

    },

    computed : {

        writeOffFileList(){

            if (this.writeOffMaterialType == -1) this.writeOffMaterialType = this.$store.getters.getWriteOffMaterialType;
            return this.$store.getters.getWriteOffFiles;

        },

        materialTypeList() {
            
            var list = this.$store.getters.getAllMaterials; // получили весь список
            return list.map((item) => {
                return {
                    value : item.id,
                    label : item.name
                }
            })

        },
        materialNomenklaturaList() {
            var list = this.$store.getters.getNomenklaturaByType(this.writeOffMaterialType);
            return list.map( (item) => {
                return {
                    value : item.id,
                    label : item.width + "м "+ item.name,
                }
            });
        },

    },


}
</script>

<style lang="scss" scoped>

    .write-off-button-container{
        margin: 7px;
        margin-top:10px;
        
    }

    .control-container {
        max-width : 310px;
        padding:10px;
        border-left : 2px solid white;
        background: rgb(223, 223, 223);
    }
    .writeOff-container {
        position : fixed;
        bottom : 0px;
        width:100%;
    }
    .open-panel {
        width:100%;
        height: 20px;
        background: rgba(78, 78, 78, 0.5);
        cursor : pointer;
        color : rgba(255, 255, 255, 0.658);
        font-family: Arial, Helvetica, sans-serif;
        font-size:12px;
        text-align:center;
        padding-top:2px;
    }

    .open-panel2 {
        width:100%;
        height: 20px;
        background: rgba(255, 95, 95, 0.8);
        cursor : default;
        color : rgba(255, 255, 255, 0.8);
        font-family: Arial, Helvetica, sans-serif;
        font-size:13px;
        text-align:center;
        padding-top:2px;
    }

    .open-panel-opened {
       background: rgba(1, 124, 32, 0.9);
       height:30px;
       padding:8px; 
    }
    .file-container {
        width : 100%;
        height: auto;
        min-height : 120px;
        background: rgba(201, 201, 201, 1);
        padding:2px;
    }

</style>
